import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { collaborationTypes } from "../../mock/DropdownOptions";
import { requestCollab } from "../../service/MainService";
import { toast } from "react-toastify";

export default function RequestCollabModal({ open, setOpen, projectDetails }) {
  const cancelButtonRef = useRef(null);
  const [requestData, setRequestData] = useState({
    CollaborationTypes: "",
    CollaborationParticipants: "",
  });
  const [mainCategory, setMainCategory] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const [occupation, setOccupation] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem("accessToken");
      const userId = projectDetails.user.UserId;
      const userName = projectDetails.user.UserName;
      const collabId = parseInt(localStorage.getItem("userId"), 10);
      const collabName = localStorage.getItem("name");
      const projectId = projectDetails.ProjectId;
      const projectName = projectDetails.ProjectName;
      const picture = localStorage.getItem("profilePicture");

      const response = await requestCollab(
        requestData,
        userId,
        token,
        collabId,
        projectId,
        projectName,
        userName,
        collabName,
        picture
      );

      if (response) {
        setRequestData({
          CollaborationTypes: "",
          CollaborationParticipants: "",
        });
        toast.success("Request sent");
        setOpen(false);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Something went wrong");
    }
  };

  const handleMainCategoryChange = (event) => {
    setMainCategory(event.target.value);
    setSubCategory(null);
    setRequestData({
      ...requestData,
      CollaborationTypes: event.target.value,
    });
  };

  const handleSubCategoryChange = (event) => {
    setSubCategory(event.target.value);
    setRequestData({
      ...requestData,
      CollaborationParticipants: event.target.value,
    });
  };

  useEffect(() => {
    const storedOccupation = localStorage.getItem("occupation");
    setOccupation(storedOccupation);

    if (storedOccupation === "Product") {
      setMainCategory("Product");
    } else {
      setMainCategory(null);
      setSubCategory(null);
    }
  }, []);

  const mainCategoryOptions = occupation === "Product"
    ? [{ label: "Product", value: "Product" }]
    : collaborationTypes.map((category) => ({
        label: category.label,
        value: category.value,
      }));

  const subCategoryOptions = mainCategory
    ? collaborationTypes.find((category) => category.value === mainCategory)?.participants || []
    : [];

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <form onSubmit={handleSubmit}>
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900 mb-5"
                        >
                          Request for Collaboration
                        </Dialog.Title>
                        <div className="mt-2">
                          <label
                            htmlFor="mainCategory"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Collaboration Type
                          </label>
                          <select
                            id="mainCategory"
                            name="mainCategory"
                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                            value={mainCategory}
                            onChange={handleMainCategoryChange}
                          >
                            <option value="">Select</option>
                            {mainCategoryOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mt-5">
                          <label
                            htmlFor="subCategory"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Collaboration Participants
                          </label>
                          <select
                            id="subCategory"
                            name="subCategory"
                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                            value={subCategory}
                            onChange={handleSubCategoryChange}
                          >
                            <option value="">Select</option>
                            {subCategoryOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    >
                      Send Request
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
